<template>
  <div
    class="rfp-rr-title-section-174-or rr-title-section"
    :class="{ 'rfp-rr-rating-rtl': isRightToLeftActive }"
  >
    <p
      class="rfp-rr-title-section-175-or float-left"
      :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
    >
      {{ sectionTitle }}
    </p>
    <div
      v-if="writeReviewEnable"
      role="button"
      tabindex="0"
      class="rfp-rr-title-section-176-or write-review-btn float-right"
      :class="{ 'rfp-rr-rating-rtl-float-left': isRightToLeftActive }"
      @click="writeReviewStatus"
    >
      {{ reviewPopupButton }}
    </div>
  </div>
</template>

<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
import eventBus from '@loreal/eventbus-js';

export default {
  name: 'rfp-ratings-title-section',
  props: {
    sectionTitle: {
      type: String,
      required: true,
    },
    reviewPopupButton: {
      type: String,
      required: true,
    },
    productItemId: {
      type: String,
      required: true,
    },
    writeReviewEnable: {
      type: Boolean,
      required: true,
    },
    isRightToLeftActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeSlider: false,
    };
  },
  created() {
    /* istanbul ignore next */
    eventBus.on('activeSliderCall', () => {
      this.activeSlider = false;
    });
    /* istanbul ignore next */
    eventBus.on('activeSliderCallTrue', () => {
      this.activeSlider = true;
    });
    /* istanbul ignore next */
    eventBus.on('rfp-ratings-write-review', () => {
      this.writeReviewStatus();
    });
  },
  methods: {
    hideModal() {
      this.open = false;
    },
    writeReviewStatus() {
      /* istanbul ignore next */
      eventBus.emit('WriteReviewTags', this.reviewPopupButton);
      const writeReviewCookies = 'reviewSubmit' + this.productItemId;
      /* istanbul ignore next */
      if (this.$cookies.get(writeReviewCookies) === null) {
        this.activeSlider = true;
        eventBus.emit('showWriteReview');
        eventBus.emit('ScrollFalse');
        this.activeSlider = false;
      } else if (this.$cookies.get(writeReviewCookies) === 'success') {
        this.activeSlider = true;
        eventBus.emit('alreadySubmitedReview');
        eventBus.emit('ScrollFalse');
      } else {
        this.activeSlider = true;
        eventBus.emit('showWarningReview');
        eventBus.emit('ScrollFalse');
      }
    },
  },
};
</script>
